import { Box, Grid } from '@creditas-ui/react';
import { SectionTitle } from '@/components/SectionTitle';
import { redirect } from '@/utils/redirect';
import {
  composeDispatchAndHandle,
  dispatchDiscoveryInsuranceReviewEvent,
  dispatchDiscoveryPayrollLoanReviewEvent,
} from '@/utils/analyticsEvents';

import i18n from '@/i18n';
import { useDiscoverySection } from './useDiscoverySection';
import * as Cards from './Cards';

const DiscoverySection = (): JSX.Element => {
  const { isSuccess, handleClickAuto, handleClickHome } = useDiscoverySection();

  return (
    <Box>
      <SectionTitle>{i18n.t('discoverySection:discovery.title')}</SectionTitle>

      <Grid
        marginTop={{ _: '24px', '5xl': '22px' }}
        marginBottom={{ _: '48px', '5xl': '68px' }}
        gridGap={20}
        gridTemplateColumns="1fr 1fr"
        gridTemplateRows={{ _: '160px 160px', '5xl': '184px 184px' }}
      >
        {isSuccess && (
          <>
            <Cards.CardAutoEquity onClick={handleClickAuto} />

            <Cards.CardHomeEquity onClick={handleClickHome} />

            <Cards.CardInsurance
              onClick={composeDispatchAndHandle(dispatchDiscoveryInsuranceReviewEvent, () => {
                redirect(i18n.t('discoverySection:cards.insurance.link'));
              })}
            />
            <Cards.CardPayrollLoan
              onClick={composeDispatchAndHandle(dispatchDiscoveryPayrollLoanReviewEvent, () => {
                redirect(i18n.t('discoverySection:cards.payroll_loan.link'));
              })}
            />
          </>
        )}
      </Grid>
    </Box>
  );
};

export { DiscoverySection };
